import { XIcon } from "lucide-react";
import IconButton from "..";
import { RestrictUserIcon } from "@/constant/imagePath";

const CancelButton = ({
  icon = RestrictUserIcon,
  borderColor = "#C96500",
  fromColor = "#E7A000",
  toColor = "#C96500",
  buttonStyle = { padding: "3.3px 2.5px" },
  onClick = null,
  tooltipText = "Cancel",
  ...props
}) => {
  return (
    <IconButton
      icon={icon}
      buttonStyle={{
        color: "white",
      }}
      borderColor={borderColor}
      fromColor={fromColor}
      toColor={toColor}
      onClick={onClick}
      buttonStyle={buttonStyle}
      tooltipText={tooltipText}
      {...props}
    />
  );
};

export default CancelButton;
